/* eslint-disable react/jsx-pascal-case */
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Paper from "@material-ui/core/Paper";
import FrameAppBar from "./FrameAppBar";
import QuotePage from "./QuotePage";
import { GetHTMLColour, BaseURL, encodeJobNumber } from "../../components/Common";
import {
    updateJobState,
    updateDistributor,
    updateJobUser,
    UPDATE_QUOTE_PARAMETERS,
    updateJobParameter,
} from "../../redux_store/jobState";
import QuotePageEditExtras from "./QuotePageEditExtras";
import { MANUFACTURER } from "../../AppConfig";
import { engineeringPassed } from "../../redux_store/jobState_Validation";
import BSL_DatePicker, { isDateValid } from "../../components/BSL_DatePicker";
import { isPriceRiseActive } from "../../helper/PriceRise";
import { printing_rule_failed } from "../../helper/Report";
import { addStatusTrackingEntry, formatDateLocal } from "../../helper/Helper";
import NonStandardDeliveryDialog from "./NonStandardDeliveryDialog";

export default (props) => {
    const dispatch = useDispatch();
    const job = useSelector((state) => state.job);
    const config = useSelector((state) => state.config);
    const app = useSelector((state) => state.app);
    const user = useSelector((state) => state.app.user);

    const { toggleQuoteOpen } = props;
    const [showEditExtraItems, setShowEditExtraItems] = React.useState(false);

    let manufacturer = useSelector((state) => state.app.manufacturer);
    if (window.LYSAGHT) manufacturer = { ...MANUFACTURER.Lysaght, Logo: BaseURL(MANUFACTURER.Lysaght.Logo) };

    const updateJobStateDelegate = (section, parameter, value) => {
        dispatch(updateJobState(section, parameter, value));
    };

    const updateDistributorDelegate = (value) => {
        dispatch(updateDistributor(value));
    };

    const updateUserDelegate = (value) => {
        dispatch(updateJobUser(value));
    };

    let { engValid } = engineeringPassed({ job });

    useEffect(() => {
        if (["New", "Lead", "Design"].includes(job.Status)) {
            const updatedStatusTracking = addStatusTrackingEntry("Quoted", job?.StatusTracking);

            dispatch(
                updateJobParameter(null, {
                    Status: "Quoted",
                    StatusTracking: updatedStatusTracking,
                })
            );
        }
    }, [job.Status]);

    const printing_failed = printing_rule_failed({ job, config });

    return (
        <Paper
            elevation={20}
            style={{ width: "100%", height: "100%", background: "#CCC", display: "flex", flexDirection: "column" }}
        >
            {/* Temporarily disabled */}
            {job?.SiteParameters?.NonStandardDeliveryArea && false && (
                <NonStandardDeliveryDialog area={job?.SiteParameters?.NonStandardDeliveryArea} />
            )}
            {engValid ? (
                <FrameAppBar
                    title={"Quote for #" + job.id}
                    disabled={!!printing_failed}
                    onClick={toggleQuoteOpen}
                    button1Text={
                        printing_failed ? "PRINTING LOCKED - " + printing_failed : "CREATE PDF for Printing or Emailing"
                    }
                    button1Click={props.toggleGenerateQuoteAndDocumentOpen}
                    DatePickerComponent={
                        isPriceRiseActive(app) && (
                            <BSL_DatePicker
                                label="Expected Delivery Date."
                                disableForwardDays={14} // 2 Weeks minimum delivery date.
                                tight
                                disabled={job?.DOrderStatus != null}
                                value={job?.QuoteParameters?.DeliveryDate}
                                onChange={(date) => {
                                    updateJobStateDelegate(
                                        UPDATE_QUOTE_PARAMETERS,
                                        "DeliveryDate",
                                        formatDateLocal(date)
                                    );
                                }}
                                style={{ width: "240px", flex: "none" }}
                            />
                        )
                    }
                />
            ) : (
                <FrameAppBar
                    title={"Quote for #" + job.id}
                    onClick={toggleQuoteOpen}
                    DatePickerComponent={
                        isPriceRiseActive(app) && (
                            <BSL_DatePicker
                                label="Expected Delivery Date."
                                disableForwardDays={14} // 2 Weeks minimum delivery date.
                                tight
                                disabled={job?.DOrderStatus != null}
                                value={job?.QuoteParameters?.DeliveryDate}
                                onChange={(date) => {
                                    updateJobStateDelegate(
                                        UPDATE_QUOTE_PARAMETERS,
                                        "DeliveryDate",
                                        formatDateLocal(date)
                                    );
                                }}
                                style={{ width: "240px", flex: "none" }}
                            />
                        )
                    }
                    text1={
                        <p
                            style={{
                                color: "red",
                                fontWeight: "bold",
                                backgroundColor: "white",
                                padding: "10px",
                                borderRadius: "10px",
                            }}
                        >
                            Engineering Failed. Cannot Print
                        </p>
                    }
                />
            )}

            <div
                style={{
                    overflow: "auto",
                    flex: 1,
                }}
            >
                <QuotePage
                    job={job}
                    user={user}
                    manufacturer={manufacturer}
                    updateUser={updateUserDelegate}
                    updateJobState={updateJobStateDelegate}
                    updateDistributor={updateDistributorDelegate}
                    GetHTMLColour={GetHTMLColour}
                    setShowEditExtraItems={setShowEditExtraItems}
                    footer_text={"QUOTE LAYOUT | #" + job.id + " (" + job.Customer.JobName + ")"}
                    page_number={1}
                    brandRedirect={
                        window.location.href.split("app/")[0] + "app?3d-viewer&job=" + encodeJobNumber(job?.id)
                    }
                    print={false}
                />
            </div>
            <div style={{ width: "4px", background: "#CCC", cursor: "e-resize" }}></div>

            {showEditExtraItems && (
                <QuotePageEditExtras
                    open={showEditExtraItems}
                    job={job}
                    updateJobState={updateJobStateDelegate}
                    onClose={() => {
                        setShowEditExtraItems(false);
                    }}
                />
            )}
        </Paper>
    );
};
